import { gql } from '@apollo/client';

const ORDAT_INTEGRATION_FRAGMENT = gql`
    fragment OrdatIntegrationFields on OrdatIntegrationType {
        id
        createdAt
        updatedAt
        name
        baseUrl
        username
        proxy
        companyName
        businessLine
        businessSubLine
        cultureName
        orderPushMode
        defaultShipmentType
        headerTextEnabled
        headerTextContextId
        itemTextEnabled
        itemTextContextId
        itemAdditionalTextContextId
        fallbackPartNumber
        sellablePartsOnly
        attachSourceDocuments
        priceCheckLowerThresholdPercentage
        priceCheckUpperThresholdPercentage
        capabilities
        integrationParameters
        useOutputMapping
        excludedRecordTypes
        hasCaBundle
        masterDataUpdateActive
        masterDataUpdatedAt
        masterDataUpdateError
        fetchProgress
        orderChannels {
            id
            name
        }
        rfqChannels {
            id
            name
        }
    }
`;

export const GET_ORDAT_INTEGRATIONS = gql`
    query OrdatIntegrations {
        ordatIntegrations {
            ...OrdatIntegrationFields
        }
    }
    ${ORDAT_INTEGRATION_FRAGMENT}
`;

export const GET_ORDAT_INTEGRATION_PARAMETER_DEFINITIONS = gql`
    query OrdatIntegrationParameterDefinitions {
        ordatIntegrationParameterDefinitions {
            key
            type
            default
            description
        }
    }
`;

export const CREATE_ORDAT_INTEGRATION = gql`
    mutation CreateOrdatIntegration(
        $name: String!
        $baseUrl: String!
        $username: String!
        $password: String!
        $proxy: String
        $caBundle: String
        $companyName: String
        $businessLine: String
        $businessSubLine: String
        $cultureName: String
        $orderPushMode: String
        $defaultShipmentType: String
        $headerTextEnabled: Boolean
        $headerTextContextId: String
        $itemTextEnabled: Boolean
        $itemTextContextId: String
        $itemAdditionalTextContextId: Int
        $fallbackPartNumber: String
        $sellablePartsOnly: Boolean
        $attachSourceDocuments: Boolean
        $priceCheckLowerThresholdPercentage: Float
        $priceCheckUpperThresholdPercentage: Float
        $integrationParameters: JSONString
        $useOutputMapping: Boolean
        $orderChannels: [UUID]
        $rfqChannels: [UUID]
    ) {
        createOrdatIntegration(
            name: $name
            baseUrl: $baseUrl
            username: $username
            password: $password
            proxy: $proxy
            caBundle: $caBundle
            companyName: $companyName
            businessLine: $businessLine
            businessSubLine: $businessSubLine
            cultureName: $cultureName
            orderPushMode: $orderPushMode
            defaultShipmentType: $defaultShipmentType
            headerTextEnabled: $headerTextEnabled
            headerTextContextId: $headerTextContextId
            itemTextEnabled: $itemTextEnabled
            itemTextContextId: $itemTextContextId
            itemAdditionalTextContextId: $itemAdditionalTextContextId
            fallbackPartNumber: $fallbackPartNumber
            sellablePartsOnly: $sellablePartsOnly
            attachSourceDocuments: $attachSourceDocuments
            priceCheckLowerThresholdPercentage: $priceCheckLowerThresholdPercentage
            priceCheckUpperThresholdPercentage: $priceCheckUpperThresholdPercentage
            integrationParameters: $integrationParameters
            useOutputMapping: $useOutputMapping
            orderChannels: $orderChannels
            rfqChannels: $rfqChannels
        ) {
            integration {
                ...OrdatIntegrationFields
            }
        }
    }
    ${ORDAT_INTEGRATION_FRAGMENT}
`;

export const UPDATE_ORDAT_INTEGRATION = gql`
    mutation UpdateOrdatIntegration(
        $id: UUID!
        $name: String
        $baseUrl: String
        $username: String
        $password: String
        $proxy: String
        $caBundle: String
        $companyName: String
        $businessLine: String
        $businessSubLine: String
        $cultureName: String
        $orderPushMode: String
        $defaultShipmentType: String
        $headerTextEnabled: Boolean
        $headerTextContextId: String
        $itemTextEnabled: Boolean
        $itemTextContextId: String
        $itemAdditionalTextContextId: Int
        $fallbackPartNumber: String
        $sellablePartsOnly: Boolean
        $attachSourceDocuments: Boolean
        $priceCheckLowerThresholdPercentage: Float
        $priceCheckUpperThresholdPercentage: Float
        $integrationParameters: JSONString
        $useOutputMapping: Boolean
        $orderChannels: [UUID]
        $rfqChannels: [UUID]
    ) {
        updateOrdatIntegration(
            id: $id
            name: $name
            baseUrl: $baseUrl
            username: $username
            password: $password
            caBundle: $caBundle
            proxy: $proxy
            companyName: $companyName
            businessLine: $businessLine
            businessSubLine: $businessSubLine
            cultureName: $cultureName
            orderPushMode: $orderPushMode
            defaultShipmentType: $defaultShipmentType
            headerTextEnabled: $headerTextEnabled
            headerTextContextId: $headerTextContextId
            itemTextEnabled: $itemTextEnabled
            itemTextContextId: $itemTextContextId
            itemAdditionalTextContextId: $itemAdditionalTextContextId
            fallbackPartNumber: $fallbackPartNumber
            sellablePartsOnly: $sellablePartsOnly
            attachSourceDocuments: $attachSourceDocuments
            priceCheckLowerThresholdPercentage: $priceCheckLowerThresholdPercentage
            priceCheckUpperThresholdPercentage: $priceCheckUpperThresholdPercentage
            integrationParameters: $integrationParameters
            useOutputMapping: $useOutputMapping
            orderChannels: $orderChannels
            rfqChannels: $rfqChannels
        ) {
            integration {
                ...OrdatIntegrationFields
            }
        }
    }
    ${ORDAT_INTEGRATION_FRAGMENT}
`;

export const DELETE_ORDAT_INTEGRATION = gql`
    mutation DeleteOrdatIntegration($id: UUID!) {
        deleteOrdatIntegration(id: $id) {
            success
        }
    }
`;

export const TRIGGER_ORDAT_INTEGRATION_MASTER_DATA_UPDATE = gql`
    mutation TriggerOrdatIntegrationMasterDataUpdate($id: UUID!) {
        triggerOrdatIntegrationMasterDataUpdate(id: $id) {
            started
        }
    }
`;

export const TEST_ORDAT_INTEGRATION_CONNECTION = gql`
    mutation TestOrdatIntegrationConnection($id: UUID!) {
        testOrdatIntegrationConnection(id: $id) {
            ok
            warnings
            errors
            capabilities
            fossRelease
            fossCompanyName
            businessLine
            businessSubLine
        }
    }
`;
